import VueRouter, { RawLocation, Route, RouteConfig } from "vue-router";

import AppDetails from "../components/marketplace/marketplaceAppsReviewPortal/AppDetails.vue";
import AppReview from "@/components/marketplace/components/AppReview.vue";
import AppReviews from "../components/marketplace/marketplaceAppsReviewPortal/appRatingReviews/AppReviews.vue";
import Dashboard from "../components/Dashboard.vue";
import DefaultLayout from "../layouts/DefaultLayout.vue";
import ElizaBilling from "../components/Eliza-Billing/ElizaBilling.vue";
import ClientPortalSettings from "../components/client-portal/ClientPortalSettings.vue";
import FeatureFeedbacks from "../components/labs/FeatureFeedbacks.vue";
import Features from "../components/labs/Features.vue";
import FormsAndSurvey from "../components/forms-survey/FormsAndSurvey.vue";
import Funnels from "../components/funnels/Funnels.vue";
import Isv from "../components/isv/isv.vue";
import LCDomains from "@/components/lc-domain/LCDomains.vue";
import LoginPage from "../components/login/LoginPage.vue";
import MarketPlaceDashboard from "../components/marketplace/marketplaceAppsReviewPortal/index.vue";
import Medias from "../components/medias/Medias.vue";
import Onboarding from "../components/onboarding/onboarding.vue";
import Reputation from "../components/reputation/Reputation.vue";
import Reselling from "../components/reselling/Reselling.vue";
import Restores from "../components/restores/Restores.vue";
import Saas from "../components/saas/Saas.vue";
import ScriptOverview from "../components/marketplace/marketplaceAppsReviewPortal/customJsReviewPortal/Script.vue";
import SupportAI from "@/components/SupportAI.vue";
import Vue from "vue";
import WhatsApp from "../components/whatsapp/WhatsApp.vue";
import Wordpress from "../components/wordpress/Wordpress.vue";
import Yext from "../components/yext/Yext.vue";
import store from "../store";

const Homepage = () =>
  import(
    /* webpackChunkName: "homepage" */ "../components/homepage/Homepage.vue"
  );

const KollabSupport = () =>
  import(
    /* webpackChunkName: "kollabSupport" */ "../components/kollab-support/Homepage.vue"
  );

const Billing = () =>
  import(
    /* webpackChunkName: "billing" */ "../components/billing/BillingV2.vue"
  );

const CompanyHome = () =>
  import(
    /* webpackChunkName: "companyHome" */ "../components/company/CompanyHome.vue"
  );

const LocationsHome = () =>
  import(
    /* webpackChunkName: "locationsHome" */ "../components/locations/LocationsHome.vue"
  );

const Logs = () =>
  import(/* webpackChunkName: "logs" */ "../components/logs/RequestLogs.vue");

const SupportAffiliatePortal = () =>
  import(
    /* webpackChunkName: "logs" */ "../components/affiliate-portal/SupportAffiliate.vue"
  );

const SupportHealthCheckPortal = () =>
  import(
    /* webpackChunkName: "logs" */ "../components/health-check-portal/SupportHealthCheckPortal.vue"
  );

const LcEmail = () =>
  import(/* webpackChunkName: "logs" */ "../components/lc-email/lc-email.vue");

const Wallet = () =>
  import(/* webpackChunkName: "logs" */ "../components/wallet/Wallet.vue");

const CustomOffers = () =>
  import(
    /* webpackChunkName: "logs" */ "../components/custom-offers/CustomOffers.vue"
  );
const LegalInfo = () =>
  import(/* webpackChunkName: "logs" */ "../components/company/LegalInfo.vue");

const AppManagement = () =>
  import(
    /* webpackChunkName: "marketplaceHome" */ "../components/marketplace/AppManagement.vue"
  );

const MarketplaceDevelopers = () =>
  import(
    /* webpackChunkName: "marketplaceDevelopers" */ "../components/marketplace/MarketplaceDevelopers.vue"
  );

const LaunchpadSegmentDetails = () =>
  import(
    /* webpackChunkName: "launchpad" */ "../components/launchpad/LaunchpadSegmentDetails.vue"
  );

const LaunchpadActionDetails = () =>
  import(
    /* webpackChunkName: "launchpad" */ "../components/launchpad/LaunchpadActionDetails.vue"
  );

const LaunchpadDashboard = () =>
  import(
    /* webpackChunkName: "launchpad" */ "../components/launchpad/LaunchpadDashboard.vue"
  );

const TourGuideDashboard = () =>
  import(
    /* webpackChunkName: "tourguide" */ "../components/tourGuidePortalApp/TourGuideDashboard.vue"
  );

const TourDetails = () =>
  import(
    /* webpackChunkName: "tourguide" */ "../components/tourGuidePortalApp/TourDetails.vue"
  );

const ActionGroupDetails = () =>
  import(
    /* webpackChunkName: "tourguide" */ "../components/tourGuidePortalApp/ActionGroupDetails.vue"
  );

const StepDetails = () =>
  import(
    /* webpackChunkName: "tourguide" */ "../components/tourGuidePortalApp/StepDetails.vue"
  );
const AiEmployee = () =>
  import(/* webpackChunkName: "ai-employee" */ "../components/ai-employee/AiEmployee.vue");

const PremiumSupport = () =>
  import(
    /* webpackChunkName: "premium-support" */ "../components/premium-support/PremiumSupport.vue"
  );

const Stripe = () =>
  import(/* webpackChunkName: "stripe" */ "../components/stripe/Stripe.vue");

const Recordings = () =>
  import(
    /* webpackChunkName: "recordings" */ "../components/recordings/Recordings.vue"
  );

const IdentityPlatform = () =>
  import(/* webpackChunkName: "identity-platform" */ "../components/users/IdentityPlatform.vue");

const IdentityPlatformClientDetails = () =>
  import(/* webpackChunkName: "identity-platform-details" */ "../components/users/IdentityPlatformClientDetails.vue");

const routes: RouteConfig[] = [
  {
    path: "/login",
    name: "login",
    component: LoginPage,
  },
  {
    path: "",
    component: DefaultLayout,
    children: [
      {
        path: "",
        redirect: "/homepage",
      },
      {
        path: "/homepage",
        name: "homepage",
        component: Homepage,
      },
      {
        path: "/dashboard",
        name: "dashboard",
        component: Dashboard,
      },
      {
        path: "/support-ai",
        name: "support-ai",
        component: SupportAI,
      },
      {
        path: "/billing",
        name: "billing",
        component: Billing,
      },
      {
        path: "/kollab-support",
        name: "kollab-support",
        component: KollabSupport,
        children: [
          {
            path: "location/:locationId",
            name: "kollab-support-location",
            component: KollabSupport,
          },
        ],
      },
      {
        path: "/eliza-billing",
        name: "eliza-billing",
        component: ElizaBilling,
      },
      {
        path: "/saas",
        name: "saas",
        component: Saas,
      },
      {
        path: "/marketplace-apps-review/rating",
        name: "marketplace-app-rating",
        component: AppReviews,
      },
      {
        path: "/marketplace-apps-review/:id",
        name: "marketplace-app",
        component: AppDetails,

        props: { default: true },
      },
      {
        path: "/marketplace-apps-review/new/:id",
        name: "marketplace-app-new",
        component: AppReview,
      },
      {
        path: "/marketplace-apps-review/templates",
        name: "marketplace-templates-review",
        component: AppReview,
      },
      {
        path: "/marketplace-apps-review/customScript/:customScriptId",
        name: "marketplace-app-customjs",
        component: ScriptOverview,
      },
      {
        path: "/marketplace-apps-review",
        name: "marketplace-apps-review",
        component: MarketPlaceDashboard,
      },
      {
        path: "/company",
        name: "company",
        component: CompanyHome,
      },
      {
        path: "/sub-accounts",
        name: "Sub Accounts",
        component: LocationsHome,
      },
      {
        path: "/client-portal-settings",
        name: "client-portal-settings",
        component: ClientPortalSettings,
      },
      {
        path: "/restores",
        name: "restores",
        component: Restores,
      },
      {
        path: "/funnels",
        name: "funnels",
        component: Funnels,
      },
      {
        path: "/identity-platform",
        name: "identity-platform",
        component: IdentityPlatform,
      },
      {
        path: "/identity-platform/:clientId",
        name: "identity-platform-client-details",
        component: IdentityPlatformClientDetails,
      },
      {
        path: "/lc-domain",
        name: "lc-domains",
        component: LCDomains,
      },
      {
        path: "/forms-surveys",
        name: "forms-surveys",
        component: FormsAndSurvey,
      },
      {
        path: "/isv",
        name: "isv",
        component: Isv,
      },
      {
        path: "/yext",
        name: "yext",
        component: Yext,
      },
      {
        path: "/wordpress",
        name: "wordpress",
        component: Wordpress,
      },
      {
        path: "/reputation",
        name: "reputation",
        component: Reputation,
      },
      {
        path: "/reselling",
        name: "reselling",
        component: Reselling,
      },
      {
        path: "/whatsapp",
        name: "whatsapp",
        component: WhatsApp,
      },
      {
        path: "/feature-feedbacks",
        name: "feature-feedbacks",
        component: FeatureFeedbacks,
      },
      {
        path: "/labs",
        name: "labs",
        component: Features,
      },
      {
        path: "/medias",
        name: "medias",
        component: Medias,
      },
      {
        path: "/onboarding",
        name: "onboarding",
        component: Onboarding,
      },
      {
        path: "/launchpad",
        name: "launchpad-dashboard",
        component: LaunchpadDashboard,
      },
      {
        path: "launchpad/actions/:id?",
        name: "launchpad-action-details",
        component: LaunchpadActionDetails,
      },
      {
        path: "launchpad/segment/:id?",
        name: "launchpad-segment-details",
        component: LaunchpadSegmentDetails,
      },
      {
        path: "tourguide",
        name: "tourguide-dashboard",
        component: TourGuideDashboard,
      },
      {
        path: "tourguide/tour/:id?",
        name: "tourguide-tour-details",
        component: TourDetails,
      },
      {
        path: "tourguide/step/:id?",
        name: "tourguide-step-details",
        component: StepDetails,
      },
      {
        path: "tourguide/action-group/:id?",
        name: "tourguide-action-group-details",
        component: ActionGroupDetails,
      },
      {
        path: "/logs",
        name: "logs",
        component: Logs,
      },
      {
        path: "/custom-offers",
        name: "custom-offers",
        component: CustomOffers,
      },
      {
        path: "/legal",
        name: "legal",
        component: LegalInfo,
      },
      {
        path: "/email-isv",
        name: "email-isv",
        component: LcEmail,
      },
      {
        path: "/support-affiliate-portal",
        name: "support-affiliate-portal",
        component: SupportAffiliatePortal,
      },
      {
        path: "/support-health-check-portal",
        name: "support-health-check-portal",
        component: SupportHealthCheckPortal,
      },
      {
        path: "/wallet",
        name: "wallet",
        component: Wallet,
      },
      {
        path: "/marketplace-app-management",
        name: "marketplace-app-management",
        component: AppManagement,
      },
      {
        path: "/marketplace-developers",
        name: "marketplace-developers",
        component: MarketplaceDevelopers,
      },
      {
        path: "/ai-employee",
        name: "ai-employee",
        component: AiEmployee,
      },
      {
        path: "/premium-support",
        name: "premium-support",
        component: PremiumSupport,
      },
      {
        path: "/stripe",
        name: "stripe",
        component: Stripe,
      },
      {
        path: "/recordings/:folder?",
        name: "recordings",
        component: Recordings,
      },
    ],
  },
];

Vue.use(VueRouter);
const router = new VueRouter({
  mode: "history",
  routes,
});

const requireAuth = async (
  to: Route,
  from: Route,
  next: (to?: RawLocation) => void
) => {
  if (to.name === "login") {
    if (!from.name) {
      const { authorized } = await store.dispatch("auth/authorized");
      return authorized ? next({ name: "homepage" }) : next();
    } else return next();
  }
  const { authorized, error } = await store.dispatch("auth/authorized");
  return authorized
    ? next()
    : next({
        name: "login",
        replace: true,
        query: error ? { error } : {},
      });
};

router.beforeEach(requireAuth);

export default router;
